<template>
    <div class="shopNav padding-20 bgc box-shadow">
        <div class="tips">店铺导航自定义设置，引导用户前往您精心设计的页面。既可帮您突出重点内容，也可让用户快速切换页面，找到所需内容。<span>了解更多</span></div>
        <div class="contentBox">
            <div class="viewBox">
                <div class="top">
                    <img :src="require('@/common/images/shop/view-top.png')" alt="">
                    <div class="shopName">{{item.name}}</div>
                </div>
                <div class="content"></div>
                <div class="navigator">
                    <div class="navItem" v-for="(obj, index) in item.sublist" :key="index">
                        <div class="imgBox">
                            <img v-lazy="obj.barimgurl" alt="">
                        </div>
                        <p :style="'color: '+ item.navtextcolorsel">{{obj.barname}}</p>
                    </div>
                </div>
            </div>
            <div class="setNavBox">
                <div class="homename">
                    <span>主页名称：</span>
                    <el-input v-model.trim="item.name" placeholder="请输入主页名称" clearable maxlength="32" show-word-limit></el-input>
                </div>
                <div class="colorSet">
                    <span>导航文字选中状态颜色：</span>
                    <el-color-picker v-model="item.navtextcolorsel"></el-color-picker>
                    <button class="reset" @click="resetColor">重置</button>
                </div>
                <div class="itemBox">
                    <!-- 第一个导航 -->
                    <div class="form navSetItem">
                        <el-form :model="item.sublist[0]" ref="navItemFirst" label-width="110px" :rules="rules">
                            <el-form-item label="名称" prop="barname" class="height-58" required>
                                <el-input v-model.trim="item.sublist[0].barname"></el-input>
                            </el-form-item>
                            <el-form-item label="图标">
                                <p class="iconTips">仅支持.png格式，不大于100KB</p>
                                <div class="iconBox">
                                    <el-form-item prop="barimgurl" :rules="{required: true, message: '请选择图标', trigger: 'blur'}">
                                        <div class="default">
                                            <div class="box">
                                                <img v-lazy="item.sublist[0].barimgurl" alt="">
                                            </div>
                                            <p class="edit" @click="editIcon(item.sublist[0],'default')">修改</p>
                                            <p class="choice">未选中</p>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="barimgurlsel" :rules="{required: true, message: '请选择图标', trigger: 'blur'}">
                                        <div class="selected">
                                            <div class="box">
                                                <img v-lazy="item.sublist[0].barimgurlsel" alt="">
                                            </div>
                                            <p class="edit" @click="editIcon(item.sublist[0], 'selected')">修改</p>
                                            <p class="choice">选中</p>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="跳转链接" prop="urltype" class="height-58" :rules="{required: true, message: '选择跳转链接', trigger: 'blur'}">
                                <el-select v-model="item.sublist[0].urltype" @click.native="choiceLink(item.sublist[0].urltype)" placeholder="请选择链接页面">
                                    <el-option @click.native="linkPage(0, item.sublist[0].urltype)" v-for="(item2, index) in indexList" :key="index" :label="item2.name" :value="item2.code"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="urlTitle text-ellipse" v-if="item.sublist[0].urltype==1">
                                <span>页面名称：</span>
                                <span v-if="!!item.sublist[0].objectdesc"><span v-if="item.sublist[0].urltypetext">{{item.sublist[0].urltypetext}} | </span>{{item.sublist[0].objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.sublist[0].urltype==2">
                                <span>商品名称：</span>
                                <span v-if="!!item.sublist[0].objectdesc">{{item.sublist[0].urltypetext}} | {{item.sublist[0].objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.sublist[0].urltype==5">
                                <span>分组名称：</span>
                                <span v-if="!!item.sublist[0].objectdesc">{{item.sublist[0].objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.sublist[0].urltype==7">
                                <span>链接：</span>
                                <span v-if="!!item.sublist[0].barurl">{{item.sublist[0].barurl}}</span>
                            </div>
                        </el-form>
                    </div>
                    <SlickList lockAxis="xy" v-model="slickList" class="slickListBox" :distance="5" @input="sortEndList">
                        <SlickItem v-for="(obj, index) in item.sublist.slice(1, item.sublist.length)" :index="index" :key="index" class="slickItemBox">
                            <div class="form navSetItem">
                                <el-form :model="obj" ref="navItem" label-width="110px">
                                    <el-form-item label="名称" prop="barname" :rules="{required: true, message: '请输入名称', trigger: 'blur'}" class="height-58">
                                        <el-input v-model.trim="obj.barname"></el-input>
                                    </el-form-item>
                                    <el-form-item label="图标" required>
                                        <p class="iconTips">仅支持.png格式，不大于100KB</p>
                                        <div class="iconBox">
                                            <el-form-item prop="barimgurl" :rules="{required: true, message: '请选择图标', trigger: 'blur'}">
                                                <div class="default">
                                                    <div class="box">
                                                        <img v-lazy="obj.barimgurl" alt="">
                                                    </div>
                                                    <p class="edit" @click="editIcon(obj, 'default')">修改</p>
                                                    <p class="choice">未选中</p>
                                                </div>
                                            </el-form-item>
                                            <el-form-item prop="barimgurlsel" :rules="{required: true, message: '请选择图标', trigger: 'blur'}">
                                                <div class="selected">
                                                    <div class="box">
                                                        <img v-lazy="obj.barimgurlsel" alt="">
                                                    </div>
                                                    <p class="edit" @click="editIcon(obj, 'selected')">修改</p>
                                                    <p class="choice">选中</p>
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="跳转链接" prop="urltype" :rules="{required: true, message: '选择跳转链接', trigger: 'blur'}" class="height-58">
                                        <el-select v-model="obj.urltype" @click.native="choiceLink(obj.urltype)" placeholder="请选择链接页面">
                                            <el-option @click.native="linkPage(index + 1, obj.urltype)" v-for="(item, index2) in pageList" :key="index2" :label="item.name" :value="item.code"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <div class="urlTitle text-ellipse" v-if="obj.urltype==1">
                                        <span>页面名称：</span>
                                        <span v-if="!!obj.objectdesc"><span v-if="obj.urltypetext">{{obj.urltypetext}} | </span>{{obj.objectdesc}}</span>
                                    </div>
                                    <div class="urlTitle text-ellipse" v-if="obj.urltype==2">
                                        <span>商品名称：</span>
                                        <span v-if="!!obj.objectdesc">{{obj.urltypetext}} | {{obj.objectdesc}}</span>
                                    </div>
                                    <div class="urlTitle text-ellipse" v-if="obj.urltype==5">
                                        <span>分组名称：</span>
                                        <span v-if="!!obj.objectdesc">{{obj.objectdesc}}</span>
                                    </div>
                                    <div class="urlTitle text-ellipse" v-if="obj.urltype==7">
                                        <span>链接：</span>
                                        <span v-if="!!obj.barurl">{{obj.barurl}}</span>
                                    </div>
                                </el-form>
                                <i class="el-icon-error" @click="delNavItem(index)"></i>
                            </div>
                        </SlickItem>
                    </SlickList>
                    <div class="addNav" @click="addNav"><i class="el-icon-circle-plus-outline"></i>添加导航</div>
                    <span class="navNum">导航数量最多5个</span>
                </div>
            </div>
        </div>
        <div class="action">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="saveNavItem">保存</el-button>
        </div>
        <edit-icon ref="editIcon" @setImageUrl="setImageUrl"></edit-icon>
        <customLink ref="customLink" @setLink='customLink' @cancel="cancel"></customLink>
        <banner ref="banner" @setShop='setLink' :index="index" @cancel="cancel"></banner>
        <group ref="group" @setGroup="setGroup" @cancel="cancel"></group>
        <commodity ref="commodity" @setCommodity="setCommodity" @cancel="cancel"></commodity>
    </div>
</template>
<script>
import EditIcon from './editIcon'
import Banner from '../dataComponents/banner'
import CustomLink from '../dataComponents/customLink'
import Group from '../dataComponents/group'
import Commodity from '../dataComponents/commodity'
import {SlickList, SlickItem} from 'vue-slicksort'
import {getMicroPageNavView, editMicroPageNav} from 'api/api'
import {mapActions} from 'vuex'
export default {
    name: 'shopName',
    data() {
        return {
            defaultColor: '#409EFF',
            loading: false,
            slickList: [],
            shopName: '资鲸店铺',
            actionLink: null,
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '',
                name: '',
                navtextcolor: '',
                navtextcolorsel: '#409EFF',
                sublist: [
                    {
                        barimgurl: 'http://img.capwhale.com/kmc/shopbar/icon_01.png',
                        barimgurlsel: 'http://img.capwhale.com/kmc/shopbar/icon_01_sel.png',
                        barname: '',
                        barurl: '',
                        innerid: '',
                        status: 1,
                        urltype: null,
                        urltypetext: '',
                        objectdesc: '',
                        urlkeyid: ''
                    }
                ]
            },
            index: '',
            indexList: [
                {code: 6, name: '默认微页面'},
                {code: 1, name: '微页面'}
            ],
            pageList: [
                {code: 1, name: '单个微页面'},
                {code: 2, name: '单个商品'},
                {code: 3, name: '我的消息'},
                {code: 4, name: '我的已购'},
                {code: 8, name: '个人中心'},
                {code: 5, name: '商品分组'},
                {code: 6, name: '默认微页面'},
                {code: 7, name: '自定义链接'}
            ],
            paramMicroPage: {
                pagename: ''
            },
            link: '',
            rules: {
            }
        }
    },
    created() {
        this._getList()
    },
    methods: {
        back() {
            this.$router.back()
        },
        linkPage(v, type) {
            this.index = v
            if (type === 1) {
                this.$refs.banner.openDialog()
            } else if (type === 7) {
                this.$refs.customLink.openDialog()
            } else if (type === 5) {
                this.$refs.group.openDialog([this.item.sublist[v]])
            } else if (type === 2) {
                this.$refs.commodity.openDialog()
            } else {
                if (type === 3) {
                    this.item.sublist[v].urltype = 3
                } else if (type === 4) {
                    this.item.sublist[v].urltype = 4
                } else if (type === 6) {
                    this.item.sublist[v].urltype = 6
                } else if (type === 8) {
                    this.item.sublist[v].urltype = 8
                }
                // this.item.sublist[v].barurl = this.pageList[Number(this.item.sublist[v].barurl) - 1].name
                return false
            }
            // this.item.sublist[v].barurl = ''
        },
        choiceLink(urltype) {
            this.link = urltype
        },
        cancel() {
            this.item.sublist[this.index].urltype = this.link
        },
        setGroup(row) {
            this.item.sublist[this.index].urltype = 5
            this.item.sublist[this.index].objectdesc = row.name
            this.item.sublist[this.index].urlkeyid = row.innerid
        },
        setCommodity(shop) {
            this.item.sublist[this.index].urltypetext = shop.kmctypeText
            this.item.sublist[this.index].objectdesc = shop.kmcname
            this.item.sublist[this.index].urltype = 2
            this.item.sublist[this.index].urlkeyid = `${shop.kmctype}-${shop.kmcinnerid}`
        },
        setLink(page) {
            this.item.sublist[this.index].objectdesc = page.pagename
            this.item.sublist[this.index].urlkeyid = page.innerid
            this.item.sublist[this.index].urltype = 1
            if (page.isdefault) {
                this.item.sublist[this.index].urltypetext = '默认微页面'
            } else {
                this.item.sublist[this.index].urltypetext = ''
            }
        },
        customLink(link) {
            this.item.sublist[this.index].barurl = link
            this.item.sublist[this.index].urltype = 7
        },
        resetColor() {
            this.item.navtextcolorsel = this.defaultColor
        },
        setImageUrl() {

        },
        // 增加导航栏
        addNav() {
            let len = this.item.sublist.length
            if (len < 5) {
                let obj = {
                    barimgurl: '',
                    barimgurlsel: '',
                    barname: '',
                    barurl: '',
                    urltypetext: '',
                    objectdesc: ''
                }
                this.item.sublist.push(obj)
            } else {
                this.$message({
                    type: 'warning',
                    message: '导航栏最多五个哦！！'
                })
            }
        },
        // 删除导航栏
        delNavItem(index) {
            this.item.sublist.splice(index + 1, 1)
        },
        // 修改图标
        editIcon(obj, type) {
            this.$refs.editIcon.openDialog(obj, type)
        },
        sortEndList(list) {
            this.item.sublist = [this.item.sublist[0]].concat(list)
        },
        // 保存导航
        saveNavItem() {
            if (!this.item.name) {
                this.$message.error('请输入主页名称')
            } else {
                let checkArr = []
                this.$refs.navItemFirst.validate(firstV => {
                    for (let i = 0; i < this.item.sublist.length - 1; i++) {
                        this.$refs.navItem[i].validate(v => {
                            checkArr.push(v)
                        })
                    }
                    for (let i = 0; i < checkArr.length; i++) {
                        if (firstV && checkArr[i]) {
                        } else {
                            return false
                        }
                    }
                    this._editMicroPageNav()
                })
            }
        },
        _editMicroPageNav() {
            this.item.sublist.forEach((obj, index) => {
                obj.barindex = index
            })
            this.setLoading(true)
            editMicroPageNav({
                data: {
                    innerid: this.item.innerid,
                    name: this.item.name,
                    navtextcolor: this.item.navtextcolor,
                    navtextcolorsel: this.item.navtextcolorsel,
                    barinfo: JSON.stringify(this.item.sublist)
                },
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$router.back()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getMicroPageNavView({
                data: {innerid: this.item.innerid},
                success: data => {
                    if (!data.data.sublist || !data.data.sublist.length) {
                        data.data.sublist = this.item.sublist
                    }
                    this.item = data.data
                    this.slickList = this.item.sublist.slice(1, this.item.sublist.length)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
    },
    computed: {},
    components: {
        SlickList, SlickItem, EditIcon, CustomLink, Banner, Commodity, Group
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopNav{
    .tips{
        height: 50px;
        background:#f5f7fa;
        box-sizing: border-box;
        margin-bottom: 20px;
        line-height: 50px;
        padding-left: 20px;
        font-size: 14px;
        color: #606266;
        span{
            color: #409EFF;
        }
    }
    .contentBox{
        display: flex;
        .urlTitle{
            margin-left: 10px;
            color: $tcolor-grey;
            font-size: 14px;
            padding: 0 10px 10px 10px
        }
        .viewBox{
            min-width: 15rem;
            max-width: 15rem;
            height: 668px;
            box-sizing: border-box;
            border: 1px solid #DCDFE6;
            position: relative;
            overflow: hidden;
            .top{
                position: relative;
                height: 64px;
                img{
                    width: 375px;
                    height: 64px;
                }
                .shopName{
                    position: absolute;
                    width: 375px;
                    text-align: center;
                    bottom: 16px;
                }
            }
            .content{
                height: 554px;
                background: #F5F7FA;
            }
            .navigator{
                display: flex;
                justify-content: space-around;
                height: 50px;
                box-sizing: border-box;
                padding: 5px 0;
                .navItem{
                    flex: 1;
                    text-align: center;
                    color: #909399;
                    font-size: 12px;
                    .imgBox{
                        height: 24px;
                        text-align: center;
                        margin-bottom: 4px;
                        img{
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
            }
        }
        .setNavBox{
            width: 548px;
            box-sizing: border-box;
            padding: 26px 20px;
            border: 1px solid #E4E7ED;
            box-shadow:0px 2px 12px 0px rgba(0,0,0,0.06);
            margin-left: 40px;
            background: #F5F7FA;
            .homename{
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                span{
                    flex-shrink: 0;
                }
            }
            .colorSet{
                height: 30px;
                line-height: 30px;
                display: flex;
                padding-bottom: 20px;
                border-bottom: 1px solid #DCDFE6;
                .el-color-picker__trigger{
                    width: 60px;
                    height: 30px;
                    border-radius: 0;
                    .el-icon-close{
                        display: none;
                    }
                    .el-color-picker__icon{
                        display: none;
                    }
                }
                .reset{
                    width: 60px;
                    height: 30px;
                    margin-left: 20px;
                    background: #F5F7FA;
                    border: 1px solid #DCDFE6;
                    outline: none;
                    cursor: pointer;
                }
            }
            .itemBox{
                padding-top: 10px;
                .slickListBox{
                    margin: 0;
                    min-height: 0;
                    background: #F5F7FA;
                    width: 506px;
                    .slickItemBox{
                        width: 506px;
                    }
                }
                .addNav{
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    border: 1px solid #DCDFE6;
                    background: #fff;
                    color: #409EFF;
                    margin: 15px 0;
                    cursor: pointer;
                }
                .navNum{
                    color: #606266;
                    font-size: 14px;
                }
            }
        }
    }
    .action{
        text-align: center;
        border-top: 1px solid #DCDFE6;
        height: 60px;
        line-height: 60px;
        margin-top: 20px;
    }
}
.navSetItem{
    border: 1px solid #DCDFE6;
    margin-top: 0;
    background: #fff;
    padding-top: 10px;
    position: relative;
    .iconTips{
        color: #909399;
        font-size: 14px;
    }
    .el-form-item{
        margin-bottom: 0px;
        .el-form-item__label{
            text-align: left;
            text-indent: 22px;
        }
    }
    .height-58{
        height: 50px;
    }
    .el-form-item__content{
        width: 240px;
        margin-left: 130px !important;
        .el-select{
            width: 185px;
        }
        .el-form-item__error{
            padding-top: 0;
            font-size: 12px;
            top: 92%;
        }
        .linkText{
            color: #909399;
        }
    }
    .iconBox{
        display: flex;
        .el-form-item{
            .el-form-item__content{
                margin-left: 0 !important;
                width: 72px;
            }
        }
        .el-form-item:last-of-type{
            .el-form-item__content{
                margin-left: 40px !important;
            }
        }
        .box{
            width: 72px;
            height: 50px;
            border: 1px solid #DCDFE6;
            box-sizing: border-box;
            text-align: center;
            line-height: 50px;
            img{
                width: 24px;
                height: 24px;
            }
        }
        .edit{
            width: 72px;
            height: 20px;
            background: #909399;
            color: #fff;
            line-height: 20px;
            text-align: center;
            cursor: pointer;
        }
        .choice{
            width: 72px;
            text-align: center;
        }
    }
    .el-icon-error{
        position: absolute;
        right: -7px;
        top: -7px;
        cursor: pointer;
        color: #909399;
    }
    .el-select{
        width: 100% !important;
        line-height: 1;
    }
}
.form{
    margin-top: 0 !important;
}
.slickItemBox{
    margin-top: 15px;
}
.lastItem{
    margin-top: 15px !important;
}
</style>
